import moment from 'moment-timezone';

export function checkInstrumentType(tickers, type) {
  return tickers.some(ticker => ticker.type === type);
}

// export function notMarket(symbol) {
//   return symbol !== 'DJIA' && symbol !== 'COMP' && symbol !== 'SPX';
// };

export function selectProps(obj, props) {
  const newObj = {};
  props.forEach(prop => newObj[prop] = obj[prop]);
  return newObj;
}

export function updateProps(props, ticker) {
  const newProps = selectProps(props, ['dateRange', 'start', 'end', 'frequency', 'isPercent', 'isRolling']);
  newProps.tickers = [...props.tickers, ticker];
  return newProps;
}

export function createNewProps(props, isCustom, categories, prop) {
  const { start, end, frequency } = props;
  const newProps = findStartEnd(isCustom, start, end, categories, frequency);  

  if (prop !== 'update') newProps[prop] = props[prop];
  
  const hasCrypto = checkCrypto(props, prop);
  if (prop === 'dateRange' || hasCrypto) newProps.frequency = frequency;
  
  return newProps;
}

export function getSourceLine(series) {
  const sources = compileSources(series);
  const sourceNames = Object.keys(sources);

  return sourceNames.length === 1 ?
    `Source: ${sourceNames[0]}`
    :
    writeMultipleSources(sourceNames, sources);
}

export function checkIntraday(frequency) {
  return frequency.includes('T') && frequency.includes('M') || frequency.includes('H')
}

export function createETMoment(date) {
  return moment.tz(date, 'America/New_York');
}

export function lastItem(arr) {
  return arr[arr.length - 1];
}

// createNewProps helper functions
function findStartEnd(isCustom, startProp, endProp, categories, frequency) {
  const [start, end] = isCustom && frequency !== 'P7D' && frequency !== 'P1M' && frequency !== 'P3M' && frequency !== 'P1Y' ?
    [startProp, endProp]
    :
    getDates(categories);
  return { start, end };
}

function getDates(categories) {
  return [categories[0], lastItem(categories)].map(formatDate);
}

function formatDate(date) {
  const isIntraday = date.split(' ').length > 1;
  if (isIntraday) date += 'm';
  const format = isIntraday ? 'MM-DD-YYYY h:mm:ss a' : 'MM-DD-YYYY';
  return moment.tz(date, format, 'America/New_York').format();
}

function checkCrypto(props, prop) {
  const { tickers } = props;
  const cryptoAdded = tickers.length && lastItem(tickers).type === 'CryptoCurrency';
  return prop === 'tickers' && cryptoAdded;
}

// getSourceLine helper functions
function compileSources(series) {
  const sources = {};

  series.forEach(currentSeries => {
    const { type, symbol, source } = currentSeries.sourceInfo;

    if (!sources[source]) sources[source] = [];
    const types = sources[source];

    if (checkMultiple(series, type, source)) {
      types.push(symbol); // when same ticker type appears under different sources, list symbol
    } else if (!types.includes(type)) {
      types.push(type); // otherwise list type
    }
  })

  return sources;
}

function checkMultiple(series, currentType, currentSource) {
  // does same ticker type appear under multiple sources?
  return series.some(currentSeries => {
    const { type, source } = currentSeries.sourceInfo;
    return type === currentType && source !== currentSource;
  });
}

function writeMultipleSources(sourceKeys, sources) {
  return sourceKeys.reduce((str, source) =>
    str + writeSource(sources, source), 'Sources: ').slice(0, -2);
}

function writeSource(sources, source) {
  return `${source} (${writeList(sources[source])}); `;
}

function writeList(listArr) {
  return listArr.reduce((str, listItem) => str + `${listItem}, `, '').slice(0, -2);
}



// WEBPACK FOOTER //
// ./src/ui/util/marketdata.js